import React from 'react';
import { IconProp } from 'src/tef/components/utils/types';

export function useIcon(icon: IconProp | undefined): React.ReactNode | null {
  if (!icon) return null;

  if (typeof icon === 'string') {
    return null;
  }

  return icon as React.ReactNode;
}
